import { type ReactNode } from 'react';

interface FieldProps {
  label?: string;
  helper?: string;
  error?: string;
  id?: string;
  children: ReactNode;
  className?: string;
}

export function Field({ label, helper, error, id, children, className = '' }: FieldProps) {
  const cls = ['field', error ? 'field--error' : '', className].filter(Boolean).join(' ');
  return (
    <div className={cls}>
      {label && (
        <label htmlFor={id} className="field__label">
          {label}
        </label>
      )}
      {children}
      {helper && !error && <p className="field__helper">{helper}</p>}
      {error && <p className="field__error">{error}</p>}
    </div>
  );
}
